import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

export const firebaseConfig = {
  // Replace with your Firebase config
  apiKey: "AIzaSyBW6_dYsY6Z54zLQqx47SSo-N9rXZvV8QA",
  authDomain: "reverbeatpro.firebaseapp.com",
  projectId: "reverbeatpro",
  storageBucket: "reverbeatpro.appspot.com",
  messagingSenderId: "249953445685",
  appId: "1:249953445685:web:e79fc94e494a2472f14e7c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
